export default {
    namespaced: true,  // 启用命名空间
    state: {
        wxUserName: "",
        deptId: "",
        hospitalId: "",
        servicePackId: "",
        disease: ""
    },
    mutations: {
        setWxUserName(state, wxUserName) {
            state.wxUserName = wxUserName;
        },
        setDeptId(state, deptId) {
            state.deptId = deptId;
        },
        setHospitalId(state, hospitalId) {
            state.hospitalId = hospitalId;
        },
        setServicePackId(state, servicePackId) {
            state.servicePackId = servicePackId;
        },
        setDisease(state, disease) {
            state.disease = disease;
        },
        setAllState(state, payload) {
            console.log(payload);
            Object.keys(payload).forEach(key => {
                if (state.hasOwnProperty(key)) {
                    state[key] = payload[key];
                }
            });
        }
    },
}